var map = {
	"./icn-banks-old.svg": 1393,
	"./icn-banks.svg": 152,
	"./icn-bf-o.svg": 567,
	"./icn-bf-y.svg": 153,
	"./icn-bf.svg": 130,
	"./icn-consumers-old.svg": 1394,
	"./icn-consumers.svg": 113,
	"./icn-engagement-shield.svg": 205,
	"./icn-engagement.svg": 1395,
	"./icn-oil-green-active.svg": 1396,
	"./icn-oil-green-inactive.svg": 1397,
	"./icn-oil-orange-active.svg": 1398,
	"./icn-oil-orange-inactive.svg": 1399,
	"./icn-oil-red-active.svg": 1400,
	"./icn-oil-red-inactive.svg": 1401,
	"./icn-oil-redorange-active.svg": 1402,
	"./icn-oil-redorange-inactive.svg": 1403,
	"./icn-oil-yellow-active.svg": 1404,
	"./icn-oil-yellow-inactive.svg": 1405,
	"./icn-po-o.svg": 568,
	"./icn-po-y.svg": 154,
	"./icn-po.svg": 131,
	"./icn-pp-o.svg": 569,
	"./icn-pp-y.svg": 155,
	"./icn-pp.svg": 132,
	"./icn-producers-old.svg": 1406,
	"./icn-producers.svg": 114,
	"./icn-rb-o.svg": 570,
	"./icn-rb-y.svg": 156,
	"./icn-rb.svg": 133,
	"./icn-socially-responsible.svg": 1407,
	"./icn-sy-o.svg": 571,
	"./icn-sy-y.svg": 157,
	"./icn-sy.svg": 134,
	"./icn-tb-o.svg": 572,
	"./icn-tb-y.svg": 158,
	"./icn-tb.svg": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1771;



//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/icn\-.*\.svg$
// module id = 1771
// module chunks = 0